export default "__VITE_ASSET__uwAoGSYS__"